export default "assets/images/4.5-stars-bfc0e543.svg";